"use strict";

exports.__esModule = true;
exports.UiDesignContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Which UI a subtree renders: `modern` is the flag-gated refresh, `screen`
 * the route group this provider covers (undefined at the root), `baseTheme`
 * the tenant theme before the modern token overlay.
 */
var UiDesignContext = exports.UiDesignContext = /*#__PURE__*/_react["default"].createContext({
  modern: false,
  screen: undefined,
  baseTheme: undefined
});